<template>
  <Transition
    :enter-active-class="$style.from"
    :leave-active-class="$style.from"
    :enter-from-class="$style.to"
    :leave-to-class="$style.to"
    appear
  >
    <slot />
  </Transition>
</template>

<style module lang="scss">
.from {
  transition: all var(--transition-cubic-fast);
}
.to {
  transform: translateX(5px) translateY(-5px);
  opacity: 0;
}
</style>
